import React from 'react';
import { string } from 'prop-types';

const CircleCross = ({ className, fill = '#F35757' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6332 6.31954C14.509 3.19534 9.44368 3.19534 6.31952 6.31954C3.19532 9.44375 3.19532 14.509 6.31952 17.6333C9.44368 20.7574 14.509 20.7574 17.6332 17.6333C20.7574 14.509 20.7574 9.44375 17.6332 6.31954ZM14.8048 10.2794C15.1172 9.96695 15.1172 9.46039 14.8048 9.14799C14.4924 8.83551 13.9858 8.83551 13.6734 9.14799L11.9764 10.845L10.2793 9.14799C9.96688 8.83551 9.46032 8.83551 9.14792 9.14799C8.83552 9.46039 8.83552 9.96695 9.14792 10.2794L10.845 11.9764L9.14792 13.6734C8.83552 13.9858 8.83552 14.4924 9.14792 14.8048C9.46032 15.1173 9.96688 15.1173 10.2793 14.8048L11.9764 13.1078L13.6734 14.8048C13.9858 15.1173 14.4924 15.1173 14.8048 14.8048C15.1172 14.4924 15.1172 13.9858 14.8048 13.6734L13.1078 11.9764L14.8048 10.2794Z"
            fill={fill}
        />
    </svg>
);

CircleCross.propTypes = {
    className: string,
};

CircleCross.defaultProps = {
    className: '',
};

export default CircleCross;
